import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { stashPostLoginRedirect } from '@/auth/post-login-redirect'
import { useAuth } from '@/hooks/useAuth'

export function LoginPage() {
	const { login, isAuthenticated, isLoading } = useAuth()
	const navigate = useNavigate()
	const location = useLocation()
	const fromState = (location.state as { from?: string } | null)?.from
	const pendingRedirect = typeof fromState === 'string' ? fromState : null

	useEffect(() => {
		if (isAuthenticated) {
			void navigate(pendingRedirect ?? '/', { replace: true })
		}
	}, [isAuthenticated, navigate, pendingRedirect])

	const handleLogin = () => {
		if (pendingRedirect) stashPostLoginRedirect(pendingRedirect)
		login()
	}

	if (isLoading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground" />
			</div>
		)
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-muted">
			<div className="max-w-md w-full space-y-8">
				<div className="text-center">
					<h1 className="text-3xl font-bold text-foreground">KXFC</h1>
					<p className="text-lg text-muted-foreground">Keenfolks X — Flight Control</p>
					<p className="mt-2 text-sm text-muted-foreground">Sign in to access the platform</p>
				</div>
				<div className="bg-white shadow rounded-lg p-8">
					<button
						type="button"
						onClick={handleLogin}
						className="w-full flex justify-center items-center gap-3 py-3 px-4 border border-border rounded-md shadow-sm text-sm font-medium text-foreground bg-white hover:bg-muted focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className="w-5 h-5" aria-hidden="true">
							<rect x="1" y="1" width="9" height="9" fill="#f25022" />
							<rect x="11" y="1" width="9" height="9" fill="#7fba00" />
							<rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
							<rect x="11" y="11" width="9" height="9" fill="#ffb900" />
						</svg>
						Sign in with Microsoft Entra ID
					</button>
				</div>
			</div>
		</div>
	)
}
